export default __webpack_public_path__ + "static/post-hero-635137aa4430da3335d939208c01046d.png";